import { getPreviousDate } from "../components/utils/dateFormate";
import apiService from "./api";

export const userService = async (domainName,date=getPreviousDate(),isRegistered=false ,dynamicParams = {},token) => {

    const url =`/api/v1/admin/users-info?domain=${domainName}&startDate=${date}&isRegistered=${isRegistered}`;
    try {
        const response = await apiService.get(url, {}, token);
        return response.data
     } catch (error) {
         throw error;
     }
}
